"use strict";var ComponentsContext = require("../../runtime/components/ComponentsContext");
var getComponentsContext = ComponentsContext.e_;

module.exports = function render(input, out) {
  var isComponent = !input.n;
  var shouldPreserve = !("i" in input) || input.i;
  var componentsContext = out.b_;

  if (typeof document === "object") {
    var isHydrate =
    componentsContext && componentsContext.f_.g_;
    var ownerComponent = out.h_.i_;
    var referenceComponent = ownerComponent;
    var key = out.j_;
    var checkKey = key;

    if (key[0] !== "@") {
      var parentComponent = componentsContext.k_.i_;
      if (ownerComponent !== parentComponent) {
        referenceComponent = parentComponent;
        checkKey += ":" + ownerComponent.id;
      }
    }

    var isPreserved =
    shouldPreserve && (
    isHydrate || referenceComponent.l_[checkKey]);

    if (isComponent) {
      out.bf(key, ownerComponent, shouldPreserve);

      if (!isPreserved && input.renderBody) {
        input.renderBody(out);
      }

      out.ef();
    } else {
      if (isPreserved) {
        if (input.b) {
          out.m_.n_ = true;
        } else {
          out.beginElement("", null, key, ownerComponent);
          out.m_.o_ = true;
          out.endElement();
        }
      } else if (input.renderBody) {
        input.renderBody(out);
      }
    }
  } else {
    if (isComponent) {
      out.bf(
      out.j_,
      out.h_.i_,
      true);

    }

    if (input.renderBody) {
      if (shouldPreserve) {
        var parentPreserved = false;

        if (componentsContext) {
          parentPreserved = componentsContext.p_;
        } else {
          componentsContext = getComponentsContext(out);
        }

        componentsContext.p_ = true;
        input.renderBody(out);
        componentsContext.p_ = parentPreserved;
      } else {
        input.renderBody(out);
      }
    }

    if (isComponent) {
      out.ef();
    }
  }
};